import { computed } from 'vue';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { useContractStore } from '@/features/Sparten';
import { hasPreviousDamage } from '@/features/Contract/Property/utils';

export const hasNoElementarGefahren: ConditionalRequestDefinition = {
  if: computed(() => useContractStore().elementargefahren.betroffen === false),
  drop: [
    'elementargefahren.erdbeben',
    'elementargefahren.erdfall',
    'elementargefahren.erdrutsch',
    'elementargefahren.schneedruck',
    'elementargefahren.lawinen',
    'elementargefahren.ueberschwemmung',
    'elementargefahren.rueckstau',
    'elementargefahren.schadenjahr',
    'elementargefahren.schadenhoehe',
    'elementargefahren.bereinigt',
    'elementargefahren.schadenursache',
    'elementargefahren.gegenmassnahmen',
    'elementargefahren.bemerkungen',
  ],
};

export const hasNoPreviousDamage: ConditionalRequestDefinition = {
  if: computed(() => !hasPreviousDamage.value),
  drop: ['vorschaden'],
};
